import React from 'react';
import { TyreIndexExplanationLightboxStore } from '../../_flux/stores/tyre_index_explanation_lightbox_store';
import { closeAction } from '../../_flux/actions/tyre_index_explanation_lightbox_actions';
import { TyreIndexExplanationLightbox } from '../../_flux/components/tyre_index_explanation_lightbox/tyre_index_explanation_lightbox';
import { handleView } from '../handle_view';

const stores = {
    state: TyreIndexExplanationLightboxStore,
};

const render = ({ state: visible }) => (
    <TyreIndexExplanationLightbox
        visible={visible}
        onClose={closeAction}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
